import { createTheme } from '@mui/material/styles';

// https://colorhunt.co/palette/6499e99eddffa6f6ffbefff7
// Another option https://colorhunt.co/palette/ebe4d1b4b4b326577ce55604
// Test themes here: https://bareynol.github.io/mui-theme-creator
// To find palettes https://m2.material.io/inline-tools/color/

declare module '@mui/material/styles' {
  interface NewBlueColor {
    A100: string;
    A400: string;
    A700: string;
  }
  interface Palette {
    lightGrey: Palette['primary'];
    newBlue: NewBlueColor;
    backgroundGrey: Palette['primary'];
    primaryDark: Palette['primary'];
    yellow: Palette['primary'];
  }
  interface PaletteOptions {
    lightGrey?: PaletteOptions['primary'];
    newBlue?: NewBlueColor;
    backgroundGrey?: PaletteOptions['primary'];
    primaryDark?: PaletteOptions['primary'];
    yellow?: PaletteOptions['primary'];
  }
}

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#6499E9',
      contrastText: '#fff',
    },
    secondary: {
      main: '#9EDDFF',
      contrastText: '#000',
    },
    primaryDark: {
      main: '#15183A',
      contrastText: '#fff',
    },
    newBlue: {
      A100: '#6293C8',
      A400: '#2A578B',
      A700: '#47BCD8', // The same as info.main
    },
    success: {
      main: '#53B721', // green
      light: '#E2F4D9', // 'rgba(114, 210, 66, 0.2)',
    },
    error: {
      main: '#E7233B', // red
      light: '#FAD4D7', // 'rgba(231, 35, 59, 0.2)',
    },
    warning: {
      main: '#CF5C09', // orange
      light: '#FEE6D7', // 'rgba(255, 141, 59, 0.2)',
    },
    info: {
      main: '#47BCD8', // light blue
      light: '#C2EBF4', // 'rgba(64, 188, 218, 0.2)',
    },
    backgroundGrey: {
      main: '#F9FAFD', // To use for background color
    },
    lightGrey: {
      main: '#C6C7C8', // rgba(166, 167, 168, 1)
    },
    yellow: {
      main: '#F9D00A',
      light: '#FFF6CB',
      contrastText: '#000',
    },
  },
  typography: {
    fontFamily: "'Jost','Roboto','sans-serif'",
  },
});

export default defaultTheme;
